import React from 'react';
import { X } from 'lucide-react';

interface ToastProps {
    message: string;
    variant?: 'success' | 'error' | 'warning' | 'info';
    onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({
    message,
    variant = 'success',
    onClose
}) => {
  const toastStyles = {
    success: 'bg-emerald-500 shadow-emerals-400/20 ring-emerald-600',
    error: 'bg-red-500 shadow-red-400/20 ring-red-600',
    warning: 'bg-yellow-500 shadow-yellow-400/20 ring-yellow-600',
    info: 'bg-blue-500 shadow-blue-400/20 ring-blue-600',
  };
  return (
    <div
      className={`fixed top-3 right-3 flex w-80 max-w-full items-center gap-4 overflow-hidden rounded px-4 py-3 text-sm text-white shadow-lg ring-1 ring-inset ${toastStyles[variant]} `}
      role="status"
    >
      <p className="flex-1">{message}</p>
      <button
        onClick={() => onclose}
        aria-label="Close"
        className="inline-flex h-8 items-center justify-center gap-2 justify-self-center whitespace-nowrap rounded-full px-4 text-xs font-medium tracking-wide text-white transition duration-300 hover:bg-emerald-50 hover:text-emerald-600 focus:bg-emerald-100 focus:text-emerald-700 focus-visible:outline-none disabled:cursor-not-allowed disabled:text-emerald-600 disabled:shadow-none disabled:hover:bg-transparent"
      >
        <span className="relative only:-mx-4">
          <X />
        </span>
      </button>
    </div>
  );
};

export default Toast;
